import { usePostHttp } from "../../http.hook";
import type { IUser } from "../../../../types/models/user.models.types";

interface IBody {
  id: string;
  otp: string;
}

interface IResponse {
  user: IUser;
  token: string;
}

export function useEphemeralVerifyOtpCommonHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/common/users/authentication/verify-otp",
  });
}
